import React, { useState, useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Badge, OverlayTrigger, Popover } from 'react-bootstrap';
import { isBoolean, isObject } from 'lodash';
import moment from 'moment';
import { useProductListingState } from '../RangePlanProductListingProvider';
import noImage from '../../../../assets/images/no-image.png';
import { shortenandHoverString } from '../../../../Components/helper';
import CommonImageComponent from '../../../../Components/Utility/CommonImage';
import Loader from '../../../../Components/Utility/Loader/Loader';

export default function ProductTesting(props) {
  const { handlePageNextInScroll, loadNextData, handleSelection, selectedIds, isSelectAll } = props;
  const { t } = useTranslation('common');
  const dateFormat = 'DD-MMM-YYYY';
  const {
    rangePlanProvider: { productsNumber, productsList },
  } = useProductListingState();

  const [expandedRowIndex, setExpandedRowIndex] = useState([]);
  const [isExpandAll, setIsExpandAll] = useState(false);

  useEffect(() => {
    if (isExpandAll && productsList?.length > 0) {
      setExpandedRowIndex(productsList.map((_, index) => index));
    }
  }, [productsList?.length]);

  const getValue = (value) => {
    if (isObject(value)) {
      return value?.name || '';
    }
    return value || '--';
  };

  const expandMoreData = (index) => {
    if (expandedRowIndex.includes(index)) {
      setIsExpandAll(false);
      setExpandedRowIndex(expandedRowIndex.filter((item) => item !== index));
    } else {
      setExpandedRowIndex([...expandedRowIndex, index]);
    }
  };

  const expandAllProdIdentifier = () => {
    if (isExpandAll) {
      setIsExpandAll(false);
      setExpandedRowIndex([]);
    } else {
      setIsExpandAll(true);
      setExpandedRowIndex(productsList?.map((_, index) => index) || []);
    }
  };
  const getStatus = (statuFlag) => {
    return statuFlag
      ? t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_TESTING.APPROVED')
      : t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_TESTING.REJECTED');
  };

  const getExpiryDate = (expiryDate) => {
    // Check if expiryDate is falsy (null, undefined, empty string)
    if (!expiryDate) {
      return <span className="date-invalid">--</span>;
    }

    const date = moment(expiryDate);
    if (!date.isValid()) {
      return <span className="date-invalid">--</span>;
    }

    return date.isBefore(moment(), 'day') ? (
      <span className="date-red">{date.format(dateFormat)}</span>
    ) : (
      <span className="date-green">{date.format(dateFormat)}</span>
    );
  };

  return (
    <div id="ProductIdentifierRPTableContainer" className="rp-scroll-container">
      <InfiniteScroll
        dataLength={productsList?.length}
        hasMore={productsList?.length < productsNumber}
        next={handlePageNextInScroll}
        loader={loadNextData && <Loader />}
        className="fixed-col-container rp-table-container"
        scrollableTarget="ProductIdentifierRPTableContainer"
      >
        <table id="RPProductTestingTable" className="table common-custom-table fixed-header mb-0">
          <thead>
            <tr>
              <th className="w-50px">
                <div className="common-checkbox margin-auto">
                  <input
                    type="checkbox"
                    onChange={(e) => handleSelection(e.target.checked)}
                    name="check_all_product_testing"
                    id="check_all_product_testing"
                    checked={isSelectAll}
                    disabled={!productsList?.length}
                  />
                  <label htmlFor="check_all_product_testing" className="chklabel" />
                </div>
              </th>
              <th className="w-50px">
                <button type="button" className="btn-up-down" aria-label={t('COMMON_LABEL.COLLAPSE')} onClick={() => expandAllProdIdentifier()}>
                  {isExpandAll ? <span className="icon-new-down-arrow-icon icon-inverse" /> : <span className="icon-new-down-arrow-icon " />}
                </button>
              </th>
              <th className="w-80px">{t('RANGE_PLANS.PRODUCT_LIST.IMAGE')}</th>
              <th className="w-220px">{t('RANGE_PLANS.PRODUCT_LIST.PRODUCT_NUMBER')}</th>
              <th className="w-200px first-fix-col">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_TESTING.TESTING_CODE')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_TESTING.DESCRIPTION')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_TESTING.TYPE')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_TESTING.MIN_PASS_RATE')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_TESTING.TEST_REPORT')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_TESTING.TEST_PRICE')}</th>

              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_TESTING.EXPIRY_DATE')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_TESTING.SUPPLIER')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_TESTING.COMPONENT')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_TESTING.COLOURWAY')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_TESTING.ADDITIONAL_INFO')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_TESTING.RESULT')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_TESTING.COMMENTS')}</th>
              <th className="w-150px last-fix-col">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_TESTING.STATUS')}</th>
            </tr>
          </thead>

          {productsList?.length > 0 ? (
            productsList?.map((ele, productIndex) => {
              const initialData = ele?.initialData;

              const productImage = ele?.image || noImage;
              return (
                <tbody key={ele?._id}>
                  <tr>
                    <td>
                      <div className="common-checkbox margin-auto">
                        <input
                          onChange={() => {
                            handleSelection(ele?._id);
                          }}
                          name={`checks_${productIndex}`}
                          id={`checks_${productIndex}`}
                          type="checkbox"
                          checked={selectedIds?.filter((val) => val === ele?._id)?.length > 0}
                        />
                        <label htmlFor={`checks_${productIndex}`} className="chklabel" />
                      </div>
                    </td>
                    <td>
                      {ele?.expandData?.length > 0 && (
                        <button type="button" className="btn-up-down" aria-label={t('COMMON_LABEL.COLLAPSE')} onClick={() => expandMoreData(productIndex)}>
                          {expandedRowIndex.includes(productIndex) ? (
                            <span className="icon-new-down-arrow-icon icon-inverse" />
                          ) : (
                            <span className="icon-new-down-arrow-icon" />
                          )}
                        </button>
                      )}
                    </td>
                    <td>
                      <CommonImageComponent productImage={productImage} />
                    </td>
                    <td>
                      <div className="d-flex align-items-center">
                        {ele?.number}
                        <button type="button" className="btn ml-auto" aria-label="info">
                          <OverlayTrigger
                            placement={t('TAKING_DATES.BUTTON')}
                            trigger="hover"
                            rootClose
                            overlay={
                              <Popover className="custom-popover">
                                <Popover.Content>
                                  <p className="mb-8">
                                    <b className="text-bold">Product Type: </b>
                                    {getValue(ele?.supplierType)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Description: </b>
                                    {getValue(ele?.description)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Brand: </b>
                                    {getValue(ele?.brandId)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Season: </b>
                                    {getValue(ele?.seasonId)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Month: </b>
                                    {getValue(ele?.month)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Year: </b>
                                    {getValue(ele?.year)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Colourway(s): </b>

                                    {ele?.colourLibraries?.map((gradEle) => gradEle?.name)?.join(', ') || '--'}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Size: </b>
                                    {ele?.sizeRanges?.join(', ') || '--'}
                                  </p>
                                </Popover.Content>
                              </Popover>
                            }
                          >
                            <span className="icon icon-Information f-20" />
                          </OverlayTrigger>
                        </button>
                      </div>
                    </td>
                    <td className="first-fix-col">
                      <div className="d-flex align-items-center">
                        {shortenandHoverString(initialData?.code || '--', 20)}
                        {initialData?.code && (
                          <Link
                            target="_blank"
                            to={`/development-order/${ele?._id}/testing/testing-requirements`}
                            className="px-3 ml-auto text-decoration-none"
                          >
                            <span className="icon-redirect f-20" />
                          </Link>
                        )}
                        <div style={{ width: 20 }}>
                          {ele?.expandData?.length >= 1 && <Badge className="range-badge badge badge-rp-counter">{(ele?.expandData?.length || 0) + 1}</Badge>}
                        </div>
                      </div>
                    </td>
                    <td>{shortenandHoverString(initialData?.description || '--', 40)}</td>
                    <td>{initialData?.type?.name || '--'}</td>
                    <td>{shortenandHoverString(initialData?.minPassRate || '--', 40)}</td>
                    <td>{initialData?.testReports?.pdfTitle || '--'}</td>
                    <td>{initialData?.testPrice || '--'}</td>
                    <td>{getExpiryDate(initialData?.testReports?.expire_on)}</td>
                    <td>{initialData?.supplier?.supplierName || '--'}</td>
                    <td>{initialData?.bomComponent?.referenceCode || '--'}</td>
                    <td>{initialData?.colour?.name || '--'}</td>
                    <td>{shortenandHoverString(initialData?.additionalInformation || '--', 40)}</td>
                    <td>{initialData?.result || '--'}</td>
                    <td>{shortenandHoverString(initialData?.comment || '--', 40)}</td>
                    <td className="last-fix-col">
                      <span className="text-capitalize">{isBoolean(initialData?.status) ? getStatus(initialData?.status) : initialData?.status}</span>
                      <p className="mb-0">{isBoolean(initialData?.status)}</p>
                      <p className="mb-0">{initialData?.selectedDate && moment(initialData?.selectedDate).format(dateFormat)}</p>
                    </td>
                  </tr>
                  {expandedRowIndex.includes(productIndex) &&
                    ele?.expandData?.map((expData) => {
                      return (
                        <tr className="expand-row" key={expData?._id}>
                          <td />
                          <td />
                          <td />
                          <td />
                          <td className="first-fix-col">{shortenandHoverString(expData?.code || '--', 50)}</td>
                          <td>{shortenandHoverString(expData?.description || '--', 40)}</td>
                          <td>{expData?.type?.name || '--'}</td>
                          <td>{shortenandHoverString(expData?.minPassRate || '--', 40)}</td>
                          <td>{expData?.testReports?.pdfTitle || '--'}</td>
                          <td>{expData?.testPrice || '--'}</td>
                          <td>{getExpiryDate(expData?.testReports?.expire_on)}</td>
                          <td>{expData?.supplier?.supplierName || '--'}</td>
                          <td>{expData?.bomComponent?.referenceCode || '--'}</td>
                          <td>{expData?.colour?.name || '--'}</td>
                          <td>{shortenandHoverString(expData?.additionalInformation || '--', 40)}</td>
                          <td>{expData?.result || '--'}</td>
                          <td>{shortenandHoverString(expData?.comment || '--', 40)}</td>
                          <td className="last-fix-col">
                            <span className="text-capitalize">
                              {isBoolean(expData?.status)
                                ? getStatus(expData?.status)
                                : expData?.status || t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_TESTING.PENDING')}
                            </span>
                            <p className="mb-0">{isBoolean(expData?.status)}</p>
                            <p className="mb-0">{expData?.selectedDate && moment(expData?.selectedDate).format(dateFormat)}</p>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              );
            })
          ) : (
            <tr>
              <td colSpan={21} className="text-center">
                {t('RANGE_PLANS.PRODUCT_LIST.NO_RECORDS_FOUND')}
              </td>
            </tr>
          )}
        </table>
      </InfiniteScroll>
    </div>
  );
}
